import React from 'react';
import PropTypes from 'prop-types';
import { SearchSegment } from '../../../../../models';
import { DateUtils } from '../../../../../utils';
import { HeaderDates } from './HeaderDates';

export const HeaderDatesSegments = ({ segments }) => {
    if (!segments.length) {
        return React.Fragment;
    }

    const dates = DateUtils.stringToDate([segments[0].date]);
    if (segments.length > 1) {
        dates.push(segments[segments.length-1].date);
    }

    return <HeaderDates dates={dates} />;
};

HeaderDatesSegments.propTypes = {
    segments: PropTypes.arrayOf(SearchSegment),
};

HeaderDatesSegments.defaultProps = {
    segments: [],
};
